import { useContext } from "react";
import { PaymentMethodsContext } from "./PaymentMethodsProvider";

export default function usePaymentMethodsContext() {
    return useContext(PaymentMethodsContext);
};
